import './Certificate.css'

const Certificate = ({onClick, image, date, title, description, issuer}) => {
    return (
        <div className='certificate-container'>
            <img className='certificate-image' src={image} alt='Dont look at me! its not my fault.'></img>
            <div className='certificate-text-content'>
                <div>
                    <div className='certificate-title-date-container'>
                        <span className='certificate-title'>{title}</span>
                        <span className='certificate-date'>{date}</span>
                    </div>
                    <span className='certificate-location'>{issuer}</span>
                </div>
                <span className='certificate-description'>{description}</span>
                <span className='certificate-link' onClick={onClick}>View Certificate</span>
            </div>
        </div>
    )
}

export default Certificate
